import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";

export const checkPermission = () => {
  let is_staff = localStorage.getItem("user_type");
  let doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
  let clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
 return (clinicId && doctorRole === "Administrator") || is_staff === "staff";    
};
